import { getSelectedColumns, getSelectedColumnsCategory } from './selectors';
import { NUMERICALSUMMARY_COLUMNS, CATEGORICAL_SUMMARY_COLUMNS } from '../../components/NumericalSummary/columns';

import {
  SET_SELECTED_STATS,
  TOGGLE_SELECTED_STATS_VISIBILITY
} from './types';

export const toggleSelectedStatVisibility = statsName => ({
  type: TOGGLE_SELECTED_STATS_VISIBILITY, statsName
});

export const setSelectedStats = () => dispatch => {
  const statFilterNumerical = getSelectedColumns(Object.keys(NUMERICALSUMMARY_COLUMNS), true);
  const stateFilterCategorical = getSelectedColumnsCategory(Object.keys(CATEGORICAL_SUMMARY_COLUMNS));
  const statFilters = { ...statFilterNumerical, ...stateFilterCategorical };

  dispatch({ type: SET_SELECTED_STATS, statFilters });
};
